import { print } from "graphql";
import { BaseAPI } from '@/api/base.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import { Pagination } from './pagination';
import { PageUsuarioInput, Usuario } from '@/models/usuario';
import { API_URL_SERVICE } from "@/commons/config";

const usuarioPage = require('@/query/usuario/Page.graphql')
const usuarioShow = require('@/query/usuario/Show.graphql')

export class UsuarioAPI extends BaseAPI<Usuario> {
  constructor() {
    super();
    this.backUrl = `${this.backUrl}/users`;
    this.apiUrl = `${this.apiUrl}/api_dash/v1/users`;
  }

  public create(body: any): AxiosObservable<Usuario> {
    return this.axios.post(`${this.apiUrl}`, body);
  }

  public list(params: any): AxiosObservable<Pagination<Usuario>> {
    return this.axios.get(`${this.apiUrl}`, { params: this.buildFiltered(params) });
  }

  public show(id: number): AxiosObservable<Usuario> {
    return this.axios.get(`${this.apiUrl}/${id}`)
  }

  public update(id: number, body: any): AxiosObservable<Usuario> {
    return this.axios.patch(`${this.apiUrl}/${id}`, body)
  }
}
